import styled from 'styled-components';
import Button from '@mui/material/Button';

export const Wrapper = styled.div`
  .btn-remove {
    padding: 2px;

    svg {
      font-size: 16px;
    }
  }

  .companies-table {
    .MuiTableContainer-root {
      max-width: calc(100vw - 80px);
    }
  }

  .sector-item {
    border: 1px solid rgb(0 0 0 / 0.1);
  }

  .tab-icon {
    width: 26px;
  }

  ${(props) => props.theme.breakpoints.down(768)} {
    .companies-table {
      .MuiTableContainer-root {
        max-width: calc(100vw - 56px);
      }
    }
  }

  ${(props) => props.theme.breakpoints.down(520)} {
    .header-follow-companies {
      flex-wrap: wrap;

      & > div {
        width: 100%;
        margin-top: 5px;
      }
    }
  }

  ${(props) => props.theme.breakpoints.down(425)} {
    .follow-company-heading {
      flex-direction: column;
    }
  }
`;

export const FollowCategoriesWrapper = styled.div`
  .MuiPopper-root {
    z-index: 500;
  }
`;

export const MenuWrapper = styled.div`
  min-width: 280px;

  .MuiIconButton-root svg {
    font-size: 18px;
  }
`;

export const FakeDropdown = styled(Button)`
  &.MuiButton-root {
    justify-content: flex-start;
    width: 100%;
    padding: 8.5px 8px 8.5px 7px;
    font-size: 14px;
    background: ${(props) => props.theme.input.background};
    border: 1px solid ${(props) => props.theme.input.border};
    border-radius: 4px;
    color: ${(props) => props.theme.palette.text.primary};

    span {
      display: inline-block;
      text-align: left;
      text-overflow: ellipsis;
      overflow: hidden;
      width: calc(100% - 30px);
      white-space: nowrap;
    }

    &:hover {
      background: ${(props) => props.theme.input.background};
      border-color: ${(props) => props.theme.input.border};
      box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);
    }

    .MuiSvgIcon-root {
      transition: all 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    }

    .MuiTouchRipple-root {
      display: none;
    }

    &.opened {
      .MuiSvgIcon-root {
        transform: rotate(-180deg);
      }
    }
  }
`;

export const EmptyTag = styled.div`
  display: flex;
  width: 100%;
  height: 100px;
`;
